import React, { useState } from 'react';

// Анимированный выбор типа операции: появляются 4 иконки с подписями
export default function TypePicker({ onPick, onCancel }) {
  const [leaving, setLeaving] = useState(false);

  const options = [
    { type: 'expense', label: 'Расход', icon: '−' },
    { type: 'income', label: 'Доход', icon: '+' },
    { type: 'transfer', label: 'Перевод', icon: '↔️' },
    { type: 'debt', label: 'Долг', icon: '🤝' },
  ];

  const pick = (type) => {
    setLeaving(true);
    setTimeout(() => onPick(type), 150);
  };

  const cancel = () => {
    setLeaving(true);
    setTimeout(() => onCancel(), 150);
  };

  const iconClass = (type) => {
    if (type === 'expense') return ' type-minus';
    if (type === 'income') return ' type-plus';
    return '';
  };

  return (
    <div className={`type-picker${leaving ? ' type-picker-leave' : ''}`}>
      <div className="type-picker-title">Что добавить?</div>
      <div className="type-picker-grid">
        {options.map((o, i) => (
          <button
            key={o.type}
            type="button"
            className="type-picker-item"
            style={{ animationDelay: `${i * 60}ms` }}
            onClick={() => pick(o.type)}
          >
            <span className={`type-picker-icon${iconClass(o.type)}`}>{o.icon}</span>
            <span className="type-picker-label">{o.label}</span>
          </button>
        ))}
      </div>
      <button type="button" className="secondary type-picker-cancel" onClick={cancel}>Отмена</button>
    </div>
  );
}
